import type { EditAsideVersion, EditComponentProperty } from '@nodeTypeConfig/configTypes';
import { any } from 'prop-types';
import type React from 'react';
import { useInitialValue } from '../../../hooks/UseInitialValue';
import SimpleInput from './SimpleInput';

const AsideVersion: React.FC<{ config: EditAsideVersion; readonly: boolean }> = ({
  config,
  readonly,
}) => {
  const initialValue = useInitialValue(config.property as EditComponentProperty);

  return (
    <SimpleInput
      defaultValue={initialValue}
      label={config.label}
      readOnly={readonly}
      onChange={(_value) => {}}
    />
  );
};

AsideVersion.displayName = 'AsideVersion';

export default AsideVersion;

AsideVersion.propTypes = {
  config: any,
  readonly: any,
};
